import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Parallax, Navigation } from "swiper/modules";
import { useTranslations } from '../../locales/useTranslations';
import {
    BiLogoReact, BiLogoVuejs, BiLogoAngular, BiLogoNodejs,
    BiLogoPython, BiLogoPhp,
    BiLogoMongodb, BiLogoPostgresql, BiLogoDocker,
    BiLogoAws, BiLogoMicrosoft,
} from "react-icons/bi";
import { SiMariadb } from "react-icons/si";

const SoftwareDevelopmentTechnologies = () => {
    const { t } = useTranslations();

    const technologies = [
        {
            category: t("softwareDevelopment_technologies_frontend_title"),
            items: [
                { name: "React", icon: BiLogoReact, description: t("softwareDevelopment_technologies_react") },
                { name: "Vue.js", icon: BiLogoVuejs, description: t("softwareDevelopment_technologies_vuejs") },
                { name: "Angular", icon: BiLogoAngular, description: t("softwareDevelopment_technologies_angular") }
            ]
        },
        {
            category: t("softwareDevelopment_technologies_backend_title"),
            items: [
                { name: "Node.js", icon: BiLogoNodejs, description: t("softwareDevelopment_technologies_nodejs") },
                { name: "Python", icon: BiLogoPython, description: t("softwareDevelopment_technologies_python") },
                { name: "PHP", icon: BiLogoPhp, description: t("softwareDevelopment_technologies_php") }
            ]
        },
        {
            category: t("softwareDevelopment_technologies_database_title"),
            items: [
                { name: "MongoDB", icon: BiLogoMongodb, description: t("softwareDevelopment_technologies_mongodb") },
                { name: "PostgreSQL", icon: BiLogoPostgresql, description: t("softwareDevelopment_technologies_postgresql") },
                { name: "MySQL", icon: SiMariadb, description: t("softwareDevelopment_technologies_mysql") }
            ]
        },
        {
            category: t("softwareDevelopment_technologies_devops_title"),
            items: [
                { name: "Docker", icon: BiLogoDocker, description: t("softwareDevelopment_technologies_docker") },
                { name: "AWS", icon: BiLogoAws, description: t("softwareDevelopment_technologies_aws") },
                { name: "Azure", icon: BiLogoMicrosoft, description: t("softwareDevelopment_technologies_azure") }
            ]
        }
    ];

    return (
        <section className="ptb-100 sd-technologies">
            {/* Hintergrund-Dekoration */}
            <div className="sd-technologies__decoration sd-technologies__decoration--top-right"></div>
            <div className="sd-technologies__decoration sd-technologies__decoration--bottom-left"></div>

            <div className="container">
                <div className="section-title text-center sd-technologies__header">
                    <h2 className="sd-technologies__title">
                        {t("softwareDevelopment_technologies_title")}
                        <span className="sd-technologies__title-underline"></span>
                    </h2>
                    <p className="sd-technologies__description">
                        {t("softwareDevelopment_technologies_description")}
                    </p>
                </div>

                <Swiper
                    style={{
                        '--swiper-navigation-color': '#59bd65',
                        '--swiper-pagination-color': '#59bd65',
                        '--swiper-pagination-bullet-inactive-color': '#ddd',
                        '--swiper-pagination-bullet-inactive-opacity': '0.5',
                    }}
                    speed={800}
                    parallax={true}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true,
                    }}
                    navigation={true}
                    autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                    }}
                    modules={[Parallax, Pagination, Navigation, Autoplay]}
                    className="tech-swiper"
                    breakpoints={{
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 20
                        },
                        768: {
                            slidesPerView: 1,
                            spaceBetween: 30
                        },
                        1024: {
                            slidesPerView: 1,
                            spaceBetween: 40
                        }
                    }}
                >
                    {technologies.map((category, categoryIndex) => (
                        <SwiperSlide key={categoryIndex}>
                            <div className="sd-tech-slide">
                                <div className="sd-tech-slide__header">
                                    <h3 className="sd-tech-slide__category-title">
                                        {category.category}
                                    </h3>
                                    <div className="sd-tech-slide__category-underline"></div>
                                </div>

                                <div className="row">
                                    {category.items.map((tech, techIndex) => {
                                        const IconComponent = tech.icon;
                                        return (
                                            <div key={techIndex} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                                <div className="sd-tech-card">
                                                    <div className="sd-tech-card__icon">
                                                        <IconComponent className="sd-tech-card__icon-svg" />
                                                    </div>
                                                    <h4 className="sd-tech-card__name">
                                                        {tech.name}
                                                    </h4>
                                                    <p className="sd-tech-card__description">
                                                        {tech.description}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
};

export default SoftwareDevelopmentTechnologies;
